const EcomSegment = () => {
    return (
      
    <div>
  
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
        
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              E-commerce / COD
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Always looking for ways to add more value for its customers, TCS E-com division started offering 
              Cash-on-Delivery services in 2006. TCS offers reduced last-mile delivery costs and competitive delivery 
              promises to our customers all year-round, during peak seasons, or for specific SKUs.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS offers a one-stop solution to fulfil all e-commerce needs and empowers online businesses without 
              needing to invest in their own fulfilment facilities with tools required to meet the challenges of 
              an eternally competitive online market.
            </p>
              
          </div>
          <div className="flex-1 flex flex-col justify-center lg:mt-[0rem] mt-[1rem]">
              <img src="/overland/COD-Inside.jpg" alt="" className="max-w-[100%] rounded-md"/>
          </div>
        </div>
      
      </div>
    </div>
    );
  };
  
  export default EcomSegment;
  